<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Unscheduled Doctors",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Unscheduled Doctors",
            items: [
               {
                  text: "Unscheduled Doctors",
                  active: true,
               },                   
            ],

            listing_length: 10,
            keyword: '',

            from: null,
            to: null,
            total: null,
            pagination: {},

            doctors: [],
            token: '',
            errors: {},
            active_page_url: '',

            approve: {
               doctor_id: '',
               commision: '',
               convenience_fee: '',
            },
         };
      },
      mounted() {
         this.clearLocalStorage();
      },

      created() {
          const savedFilters = localStorage.getItem("unscheduled_doctor_filters");

         if (savedFilters) {
            const filters = JSON.parse(savedFilters);

            // Restore values
            this.keyword = filters.keyword || "";
            this.listing_length = filters.listing_length || 10;
            this.active_page_url = filters.active_page_url || null;

            // Clear stored filters
            localStorage.removeItem("unscheduled_doctor_filters");

            // Fetch consultations using restored filters
            this.fetchDoctors(this.active_page_url);
         } else {
            this.fetchDoctors(); // Load normally if no stored filters
         }
      },

      methods: {
          clearLocalStorage() {
            localStorage.removeItem("consultation_filters");
            localStorage.removeItem("patient_filters");
            localStorage.removeItem("doctor_filters");
         },
          handleProfileClick(id) {
            this.opt_button = 1;  // Set opt_button first
            this.getDetailsRoute(id);  // Then call the route function
         },
         navigateToSchedules(id) {
            this.opt_button = 2;  // Set opt_button first
            this.getDetailsRoute(id);  // Then call the route function
         },
         navigateToSessions(id) {
            this.opt_button = 3;  // Set opt_button first
            this.getDetailsRoute(id);  // Then call the route function
         },
         getDetailsRoute(id) {
            const filters = {
               keyword: this.keyword,
               listing_length: this.listing_length,
               active_page_url: this.active_page_url || this.$route.fullPath, // Store last visited page
            };
            localStorage.setItem("unscheduled_doctor_filters", JSON.stringify(filters)); // Save filters
            
            if (this.opt_button == 1) { // Now this check will pass
               this.$router.push({ name: "doctors.pending.details", params: { id: id } });
            }else if (this.opt_button == 2) { // Now this check will pass
               this.$router.push({ name: "doctors.schedules", params: { id: id } });
            }else if (this.opt_button == 3) { // Now this check will pass
               this.$router.push({ name: "doctors.sessions", params: { id: id } });
            }
         },
         fetchDoctors(page_url) {

            this.getToken();
            let url = "clinic/unscheduled-doctors?keyword=" + this.keyword + "&limit=" + this.listing_length;

            page_url = page_url || url;

            //if(localStorage.back_url) {
            //   page_url = localStorage.back_url;  
            //   localStorage.removeItem('back_url');
            //}    

            this.active_page_url = page_url;
            this.loading = true;
            
            this.$axios
               .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.doctors = responseData.doctors.data;
                  
                  this.pagination = responseData.doctors.links;
                  this.from = responseData.doctors.from;
                  this.to = responseData.doctors.to;
                  this.total = responseData.doctors.total;
               
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         }, 

         getToken() {
            if (localStorage.getItem('medicino_clinic')) {
               var medicino_clinic =  JSON.parse(localStorage.getItem('medicino_clinic'));
               if(medicino_clinic.token) {
                  this.token = medicino_clinic.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         },

      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change="fetchDoctors()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @change="fetchDoctors()"/>
                           </label>
                        </div>                                      
                        
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <th>Name</th>  
                              <th>Contact</th>
                              <th>Specializations</th>  
                              <th>Status</th>                            
                              <th>Created On</th>                              
                              <th>Options</th>
                           </tr>
                        </thead>
                        <tbody v-if="Boolean(doctors.length)">
                           <tr v-for="(doctor) in doctors" :key="doctor.id">
                              <td><span v-if="doctor.prefix == 1">Dr.</span><span v-else-if="doctor.prefix == 2">Mr.</span><span v-else-if="doctor.prefix == 3">Ms.</span>{{doctor.name}}</td>                      
                              <td>
                                 {{doctor.country_code}} {{doctor.mobile}}<br>
                                 {{doctor.email}}<br>
                              </td>
                              <td>
                                 <span v-for="(specialization) in doctor.specializations" :key="specialization.id">
                                    {{specialization.specialization}}<br>
                                 </span>
                              </td>
                              <td>
                                 <!-- <span v-if="doctor.converted_status">{{doctor.converted_status}}</span><br> -->
                                 <span class="text-danger" v-if="doctor.reg_status == 0">Pending for Doctor approval</span>
                                 <span class="text-danger" v-if="doctor.reg_status == 2">Rejected</span>
                                 <span class="text-danger" v-if="doctor.reg_status == 1 && doctor.schedules.length > 0 && doctor.schedules[0].approval_status==2">Pending for Schedule approval</span>
                                 <span class="text-danger" v-if="doctor.reg_status == 1 && doctor.schedules.length > 0 && doctor.schedules[0].approval_status==3">Schedule approval rejected</span>
                              </td>
                              <td>{{doctor.converted_created_at}}</td>
                             
                              <td>
                                 <!--<router-link :to="{ name: 'doctors.pending.details', params: {id: doctor.id} }" class="btn btn-primary me-2 mb-2 btn-sm">Profile</router-link>-->
                                 <button @click="handleProfileClick(doctor.id)" class="btn btn-primary me-2 mb-2 btn-sm" type="button">Profile</button>
                                 <!--<router-link
                                       v-if="doctor.converted_status == 'Active' && doctor.reg_status == 1 && doctor.schedules.length > 0"
                                       :to="{ name: 'doctors.schedules', params: { id: doctor.id } }"
                                       class="btn btn-primary me-2 mb-2 btn-sm"
                                 >
                                       Schedules
                                 </router-link>-->
                                  <button 
                                    v-if="doctor.converted_status == 'Active' && doctor.reg_status == 1 && doctor.schedules.length > 0"
                                    @click="navigateToSchedules(doctor.id)"
                                    class="btn btn-primary me-2 mb-2 btn-sm"
                                    type="button"
                                 >
                                    Schedules
                                 </button>

                                 <button 
                                    v-if="doctor.converted_status == 'Active' && doctor.reg_status == 1"
                                    @click="navigateToSessions(doctor.id)"
                                    class="btn btn-primary me-2 mb-2 btn-sm"
                                    type="button"
                                 >
                                    Sessions
                                 </button>
                                 <!--<router-link
                                       v-if="doctor.converted_status == 'Active' && doctor.reg_status == 1 && doctor.schedules.length === 0"
                                       :to="{ name: 'doctors.schedules', params: { id: doctor.id } }"
                                       class="btn btn-primary me-2 mb-2 btn-sm"
                                 >
                                       Add Schedule
                                 </router-link>-->
                                  <button 
                                    v-if="doctor.converted_status == 'Active' && doctor.reg_status == 1 && doctor.schedules.length === 0"
                                    @click="navigateToSchedules(doctor.id)"
                                    class="btn btn-primary me-2 mb-2 btn-sm"
                                    type="button"
                                 >
                                    Add Schedule
                                 </button>


                              </td>
                           </tr>
                        </tbody>

                        <tbody v-else>
                           <tr>
                              <td colspan="5" class="text-center">No requests found</td>
                           </tr>
                        </tbody>

                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts --->     
                  <caption v-if="Boolean(doctors.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchDoctors(page.url + '&limit='+ listing_length + '&keyword=' + keyword)">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
